import { NavLink } from "react-router-dom";

interface CardProps {
    navLink: string;
    imageName: string;
    cardTitle: string;
    cardText: string;
    badge: string;
}

export const HomePageCard: React.FC<CardProps> = ({
    navLink,
    imageName,
    cardTitle,
    cardText,
    badge,
}) => {
    return (
        <>
            <div className="col-md-6 mb-4">
                <div className="card border-primary">
                    <NavLink to={navLink}>
                        <img src={imageName} alt="" className="card-img-top" />
                    </NavLink>
                    <div className="card-body">
                        <h5 className="card-title fw-bold text-white">
                            {cardTitle}
                        </h5>
                        <p className="card-text text-primary">{cardText}</p>
                        <NavLink to={navLink}>
                            <div className="badge bg-primary text-dark p-2 text-uppercase">
                                {badge}
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    );
};
